module.exports = __webpack_public_path__ + "static/media/A.b5658e8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/A.jpg
// module id = 69
// module chunks = 0